module.exports = __webpack_public_path__ + "img/people-38-min.aacb31bf.png";